import {
  DonutIcon,
  EthereumIcon,
  LaptopIcon,
  LogoIcon,
  StarCircleIcon,
  StarIcon,
  SupportIcon,
} from '@endaoment-frontend/ui/icons';
import { Pill } from '@endaoment-frontend/ui/shared';

import { ImageButtonRow } from '../../imageButtonRow';

import styles from './AdvisorsHeader.module.scss';

export const AdvisorsHeader = () => {
  return (
    <section className={styles['advisors-header']}>
      <Pill size="large" variation="blue">
        For Financial Professionals
      </Pill>
      <h1>Full-featured philanthropic services for clients of all kinds.</h1>
      <div className={styles['advisors-header-details']}>
        <div>
          <StarCircleIcon color="#ADBACC" strokeColor="#ADBACC" width={45} height={45} />
          <p>Best-in-class donor portal</p>
        </div>
        <div>
          <SupportIcon color="#ADBACC" strokeColor="#ADBACC" width={45} height={45} />
          <p>Bespoke customer service</p>
        </div>
        <div>
          <EthereumIcon color="#ADBACC" strokeColor="#ADBACC" width={45} height={45} />
          <p>1000+ native assets accepted</p>
        </div>
        <div>
          <LaptopIcon color="#ADBACC" strokeColor="#ADBACC" width={45} height={45} />
          <p>Client directed and managed</p>
        </div>
        <div className={styles['coming-soon']}>
          <DonutIcon color="#ADBACC" strokeColor="#ADBACC" width={45} height={45} />
          <p>Yield bearing & crypto portfolio options</p>
        </div>
        <div>
          <LogoIcon color="#ADBACC" strokeColor="#ADBACC" width={45} height={45} strokeWidth={0} />
          <p>Industry-low fees, values-aligned with philanthropic throughput </p>
        </div>
      </div>
      <ImageButtonRow title="Learn More" className={styles['learn-more-container']}>
        <ImageButtonRow.Button
          label="Request a Demo"
          paragraph="Learn more about how the app works"
          icon={<StarIcon />}
          href="https://endaoment.typeform.com/request-demo"
        />
        <ImageButtonRow.Button
          label="Read our FAQ"
          paragraph="Find answers to your Endaoment questions"
          icon={<StarIcon />}
          href="/learn#faq-section"
        />
        <ImageButtonRow.Button
          label="Contact Us"
          paragraph="Contact an Endaoment representative"
          icon={<StarIcon />}
          href="mailto:partnerships@endaoment.org"
        />
      </ImageButtonRow>
    </section>
  );
};
